export let UNDEFINED;
export const EMPTY_ARGS = [];
export const bootstrapSymbol = Symbol("bootstrapModule");